import useSWR from 'swr';

async function fetchAPI(key) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${key}`);
  const responseBody = await response.json();
  return responseBody;
}

export default function StatusPage() {
  return (
    <>
      <h2>Status</h2>
      <UpdatedAt />
      <DatabaseStatus />
    </>
  );
}

function UpdatedAt() {
  const { isLoading, data } = useSWR('/status', fetchAPI, {
    refreshInterval: 2000,
  });
  let updatedAtText = 'Carregando...';
  if (!isLoading && data) {
    updatedAtText = new Date(data.updated_at).toLocaleString('pt-BR');
  }
  return (
    <>
      <div>Última atualização: {updatedAtText}</div>
      <br />
    </>
  );
}

function DatabaseStatus() {
  const { isLoading, data } = useSWR('/status', fetchAPI, {
    refreshInterval: 2000,
  });
  let databaseStatusInformation = 'Carregando...';
  if (!isLoading && data) {
    databaseStatusInformation = (
      <>
        <div>Versão: {data.dependencies.database.version}</div>
        <div>
          Conexões abertas: {data.dependencies.database.opened_connections}
        </div>
        <div>
          Conexões máximas: {data.dependencies.database.max_connections}
        </div>
      </>
    );
  }

  return (
    <>
      <h3>Database</h3>
      <div>{databaseStatusInformation}</div>
    </>
  );
}
